module.exports = __webpack_public_path__ + "static/media/img2-240-240.40b8453d.png";